export const environment = {
  development: true,
  production: false,
  //APIDEV: 'https://the-special-one.mncland.com/api/v1/',
  APIDEV: 'https://cms-property-dev.mncplay.id/api/v1/',
  //APIDEV: 'http://127.0.0.1:8000/api/v1/',
  enableServiceWorker: false,
  recaptchaSiteKey: '6LeDjqMrAAAAALoP3D0qSHw_dg1AO4pCHhud0FE1',

  // Security configurations
  security: {
    
    // Internal routes whitelist
    allowedInternalRoutes: [
      '/dashboard',
      '/userprofile',
      '/hotel',
      '/office-lease',
      '/golf',
      '/residences',
      '/sales-activities'
    ],
    
    // Maximum redirect depth untuk mencegah redirect loops
    maxRedirectDepth: 3,
    
    // Session timeout in minutes
    sessionTimeout: 30
  }
};
